module.exports = __webpack_public_path__ + "images/google_preferred_sources_btn_07d06bf36c5d97d93f5dbff7da3d02d6.webp";